import tagAdapter from "core/Utils/Analytics/tagAdapter";
import {TagTypeGa4} from "core/Utils/Analytics/tagType";
import flowIdManagment from "core/Utils/FlowIdManagment";
import { urlCallbackValidation } from "core/Utils/Utils";

const handleTagAdapter = (event, modalName) => {
  const defaultConfig = {
    "nome_item": event?.target?.text,
    "nome_modal": modalName
  }

  tagAdapter(defaultConfig,TagTypeGa4.BUTTON_MODAL);
}

function Customer2FaErrorHandler(response = {}) {
  if (!(response && response.data)) return;

  const { data } = response;
  const { error } = data;
  const { httpCode: statusCode = "no-code", errorCode } = error;
  const callbackButton = {
    disableCloseButton: true,
    buttons: [
      {
        label: "Ok, voltar",
        onClick: function () {
          flowIdManagment().removeFlowDataFromSessionStorage();
          let { urlCallback } = error;
          urlCallback = urlCallbackValidation(urlCallback);
          const url = new URL(urlCallback);
          window.location.href = url;
        },
      },
    ],
  };

  if (["CUSTOMER2FA_INVALID_CLIENT_ID"].includes(errorCode)) {
    const modalName = 'Identificação inválida';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "identificacao-invalida",
          title: modalName,
          message: 'Tivemos um problema na sua identificação. <strong>Você pode tentar novamente,</strong> busque <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou vá até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</>.',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (["CUSTOMER2FA_INVALID_TRANSACTION_TOKEN", "CUSTOMER2FA_INVALID_JWE_TOKEN"].includes(errorCode)) {
    const modalName = 'Token inválido';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "token-invalido",
          title: "Token inválido",
          message: 'Tivemos um problema no recebimento do token. <strong>Você pode tentar novamente,</strong> buscar <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou ir até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</>.',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback= urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (
    ["CUSTOMER2FA_BUREAU_CREDENTIALS_NOT_FOUND", "CUSTOMER2FA_INVALID_USER_DATA"].includes(errorCode)
  ) {
    const modalName = 'Erro de documento';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "erro-de-documento",
          title: "Erro de documento",
          message: 'Parece que tivemos um problema na conferência dos dados que precisam ser validados. <strong>Você pode tentar novamente,</strong> buscar <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou ir até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</>.',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (
    [
      "BUREAU_TOKEN_INTEGRATION_ERROR",
      "BUREAU_TRANSACTION_INTEGRATION_ERROR",
      "BUREAU_SCORE_INTEGRATION_ERROR",
      "BUREAU_RATINGS_INTEGRATION_ERROR"
    ].includes(errorCode)
  ) {
    const modalName = 'Erro de comunicação';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "erro-de-comunicacao",
          title: "Erro de comunicação",
          message: 'Parece que tivemos um problema no serviço de validação. <strong>Você pode tentar novamente,</strong> buscar <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou ir até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</a>',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (["OTP_MESSAGE_TEMPLATE_NOT_FOUND", "OTP_MESSAGE_FIELDS_NOT_FOUND"].includes(errorCode)) {
    const modalName = 'Erro de envio de código';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "erro-de-envio",
          title: "Erro de envio de código",
          message: 'Parece que tivemos um problema no envio do código. <strong>Você pode tentar novamente,</strong> buscar <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou ir até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</>',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (
    [
      "AWS_SES_INTEGRATION_ERROR",
      "STW_OTPCHANNELS_INTEGRATION_ERROR",
      "STW_OTPTOKENS_INTEGRATION_ERROR",
      "APIGEE_TOKEN_INTEGRATION_ERROR"
    ].includes(errorCode)) {
      const modalName = 'Erro sistêmico';
      window.modalName = modalName;
      window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "erro-sistemico",
          title: "Erro sistêmico",
          message: 'Parece que tivemos um problema com o nosso sistema e deve ser normalizado em breve. <strong>Você pode tentar novamente,</strong> buscar <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">atendimento</a> ou ir até uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">loja física</a>',
          disableCloseButton: true,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (["CUSTOMER2FA_BUREAU_LOW_RATING","CUSTOMER2FA_BUREAU_LOW_SCORE"].includes(errorCode)) {
    const modalName = 'Dados não aprovados';
    window.modalName = modalName;
    window.handleTagAdapter=handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "dados-nao-aprovados",
          title: "Dados não aprovados",
          message: `<strong>Lembre-se</strong>: você precisa informar os <strong>dados que sempre utiliza em outras plataformas</strong> como: redes sociais, bancos, compras online ou sites do governo. <br><br><strong> Caso esses dados principais não tenham dado certo</strong>, direcione-se à um <a onclick="handleTagAdapter(event, modalName)"  href='https://www.claro.com.br/atendimento' target='_blank'>canal de atendimento.</a>`,
          disableCloseButton: true,
          disableOnClickClose: true,
          buttons: [
            {
              label: "Tentar novamente",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback= urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ]
        },
      },
    };
  };
  
  if (["CUSTOMER2FA_BUREAU_INVALID_DOCUMENT"].includes(errorCode)) {
    const modalName = 'Atualização de dados necessária';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "transacao-invalida",
          title: "Atualização de dados necessária",
          message: 'Para pessoas jurídicas, o atendimento deve ser feito em uma <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/atendimento" target="_blank">Central de Atendimento</a> ou <a onclick="handleTagAdapter(event, modalName)"  href="https://www.claro.com.br/encontre-uma-loja" target="_blank">Procure uma loja</a> para atualizar os dados.',
          disableCloseButton: true,
          buttons: [
            {
              label: "Ir para o início",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback= urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };

  if (["CUSTOMER2FA_LOGIN_EMAIL_NOT_FOUND", "CUSTOMER2FA_LOGIN_DATA_NOT_FOUND"].includes(errorCode)) {
    const modalName = 'Atualize seus dados no Meu Perfil';
    window.modalName = modalName;
    window.handleTagAdapter = handleTagAdapter;
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "atualizar-dados",
          title: "Atualize seus dados no Meu Perfil",
          message: 'Você precisará completar as informações do seu Perfil, sendo:<br /> <br /> <p style="display: flex; flex-direction: row; align-items: center;"><i style="margin-right: 5px;" class="mdn-Icon-celular mdn-Icon--md"></i>Número de celular </p><br /> <p style="display: flex; flex-direction: row; align-items: center;"><i  style="margin-right: 5px;" class="mdn-Icon-e-mail mdn-Icon--md"></i>Dados de email de acesso </p>',
          disableCloseButton: true,
          buttons: [
            {
              label: "Meu Perfil",
              className: 'btn-primary',
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                const url = new URL(process.env.REACT_APP_MY_PROFILE_URL);
                window.location.href = url;
              },
            },
            {
              label: 'Ir para o início',
              className: 'mdn-Button mdn-Button--secondary mdn-Button--md',
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback= urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };

  if (
    [
      "CUSTOMER2FA_EXPIRED_TRANSACTION_TOKEN",
      "CUSTOMER2FA_INVALID_ACCESS_TOKEN",
      "CUSTOMER2FA_ACCESS_TOKEN_NOT_FOUND"
      ,
    ].includes(errorCode)
  ) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "O tempo de permanência no processo expirou. <strong>Você terá que reiniciar o processo.</strong>",
          disableCloseButton: true,
          buttons: [
            {
              label: "Ir para o início",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (["CUSTOMER2FA_INVALID_OTP_TOKEN"].includes(errorCode)) {
    return {
      ...data,
      code: statusCode,
      data: {
        userData: data.error?.userData ?? undefined,
      },
      error: {
        errorCode,
        warning: {
          id: "codigo-invalido",
          title: "Código inválido",
          message: "O código inserido não é o mesmo que foi enviado. <strong>Verifique o código informado e tente novamente.</strong>",
          disableCloseButton: false,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
            },
          ],
        },
      },
    };
  };
  
  if ([
    "CUSTOMER2FA_MAX_TOKEN_LIMIT_EXCEEDED",
    "CUSTOMER2FA_EXPIRED_OTP_TOKEN"
  ].includes(errorCode)) {
    return {
      ...data,
      code: statusCode,
      data: {
        userData: data.error?.userData ?? undefined,
      },
      error: {
        errorCode,
        warning: {
          id: "token-expirado",
          title: "Código expirado",
          message: "O seu código passou do limite de tempo permitido ou de tentativas permitidas. <strong>Você terá que solicitar um novo envio de código.</strong>",
          disableCloseButton: false,
          buttons: [
            {
              label: "Tentar novamente",
              className: "btn-primary",
            },
          ]
        },
      },
    };
  } ;
  
  if (["CUSTOMER2FA_DAILY_TOKEN_LIMIT_EXCEEDED"].includes(errorCode)) {
    return {
      ...data,
      code: statusCode,
      data: {
        userData: data.error?.userData ?? undefined,
      },
      error: {
        errorCode,
        warning: {
          id: "tentativas-excedidas",
          title: "Limite de tentativas excedido",
          message: "Você atingiu o limite diário do número de códigos permitido. Por favor, <strong>aguarde 24 horas e tente novamente.</strong>",
          disableCloseButton: true,
          buttons: [
            {
              label: "Ir para o início",
              onClick: function () {
                flowIdManagment().removeFlowDataFromSessionStorage();
                let { urlCallback } = error;
                urlCallback = urlCallbackValidation(urlCallback);
                const url = new URL(urlCallback);
                window.location.href = url;
              },
            },
          ],
        },
      },
    };
  };
  
  if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message:
            "Ocorreu um erro inesperado, tente novamente em alguns instantes!",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "INESPERADO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
          ...callbackButton,
        },
      },
    };
  }
}
export default Customer2FaErrorHandler;
